import { DeleteWagesParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteWages/deleteWagesQuery.type';
import { deletePropertyWagesQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteWages/deleteWagesQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const deletePropertyWagesQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  DeleteWagesParamsType
> => ({
  mutationKey: ['deletePropertyWagesQuery'],
  mutationFn: (params: DeleteWagesParamsType) =>
    deletePropertyWagesQueryFunction(params),
});
